let modelColumnType = {
  string: "String",
  number: "Number",
  bool: "Boolean",
  dict: "Dict",
  ref: "Ref",
  exRef: "ExteriorRef",
  date: "Date",
  state: "State",
  assignee: "Assignee",
  orgunit: "OrgUnit",
};
export const EVENT_TYPE = {
  OPEN_PAGE: "openPage",
  CLOSE_PAGE: "closePage",
  CALL_BACK: "callBack",
};
// 打开页面类型
export const OPEN_PAGE_TYPE = {
  DIALOG: "dialog", //
  DRAW: "draw", //
  TAB: "tab", //
  COVER: "cover",
  INNER: 'inner'
};
// 抽屉方向
export const DRAW_DIR = {
  UP: "btt", //
  DOWN: "ttb", //
  LEFT: "rtl", //
  RIGHT: "ltr",
};
// 指标枚举 默认或者自定义
export const METRIC_TYPE = {
  CUS: 'cus',
  DEFAULT: 'default'
}
export const DRAG_POSITION = {
  left: "left", //
  right: "right", //
  bottom: "bottom", //
  top: "top", //
  in: "in", //
};
export const CARD_TYPE = {
  LINE: "line", //
  BG: "bg", //
  NONE: "none", //
  OPT: "opt"
};

export const DRAG_TYPE = {
  COMPONENT: "component", //
  COMPONENT_EDIT: "componentEdit", //
  BLOCK: "block", //
};
export const MODEL_COLUMN_TYPE = {
  string: modelColumnType.string,
  number: modelColumnType.number,
  bool: modelColumnType.bool,
  dict: modelColumnType.dict,
  ref: modelColumnType.ref,
  exRef: modelColumnType.exRef,
  date: modelColumnType.date,
  state: modelColumnType.state,
  assignee: modelColumnType.assignee,
  orgunit: modelColumnType.orgunit,
  list: [
    {
      name: "字符串",
      value: modelColumnType.string,
    },
    {
      name: "数值",
      value: modelColumnType.number,
    },
    {
      name: "布尔",
      value: modelColumnType.bool,
    },
    {
      name: "字典",
      value: modelColumnType.dict,
    },
    {
      name: "引用",
      value: modelColumnType.ref,
    },
    {
      name: "外部引用",
      value: modelColumnType.exRef,
    },
    {
      name: "日期",
      value: modelColumnType.date,
    },
    {
      name: "状态",
      value: modelColumnType.state,
    },
    {
      name: "组织单元",
      value: modelColumnType.orgunit,
    },
    {
      name: "成员",
      value: modelColumnType.assignee,
    },
  ],
};

export const CHART_TYPE = {
  BAR: "bar",
  bar3D: "bar3D",
  LINE: "line",
  PIE: "pie",
  FUNNEL: "funnel",
  DASHBOARD: "dashboard",
  HEATMAP: "heatMap",
  CHINAMAP: "chinaMap",
  LINEBAR: "lineBar",
};
export const SPREAD_SHEET_TYPE = {
  BASIC: "basic", // 基础透视表
  DETAIL: "detail", // 基础明细表
};
export const DATA_SOURCE_TYPE = {
  BASIC: "basicService", //
  BIZ: "bizCount", //
  DATA_CENTER: "dataCount", //
  REPORT: "dataReport",
};
export const BIG_JUMP_TYPE = {
  AIDA: "aida", //
  EXTERNAL: "external", //
};
export const EVENT_LIST = [
  {
    name: "新页面",
    value: EVENT_TYPE.OPEN_PAGE,
  },
  {
    name: "关闭页面",
    value: EVENT_TYPE.CLOSE_PAGE,
  },
  {
    name: "发起回调",
    value: EVENT_TYPE.CALL_BACK,
  },
  {
    name: "表单校验",
    value: EVENT_TYPE.VALIDATE,
  },
];
// 表单数据项的类型
let formItemTypes = [
  {
    name: "地理位置",
    value: "location",
  },
  {
    name: "电子邮件",
    value: "email",
  },
  {
    name: "电话",
    value: "phone",
  },
  {
    name: "文本",
    value: "text",
  },
  {
    name: "富文本",
    value: "richText",
  },
  // 数字和货币暂时只用一个
  {
    name: "数字",
    value: "number",
  },
  {
    name: "货币",
    value: "currency",
  },
  {
    name: "百分比",
    value: "percentage",
  },
  {
    name: "评分",
    value: "rate",
  },
  // 为了和模型的字段类型一致 那边用的大写
  {
    name: "下拉",
    value: "Dict",
  },
  {
    name: "开关",
    value: "Boolean",
  },
  {
    name: "复选框",
    value: "checkbox",
  },
  {
    name: "链接",
    value: "link",
  },
  {
    name: "日期",
    value: "date",
  },
  {
    name: "时间",
    value: "time",
  },
  {
    name: "日期时间",
    value: "datetime",
  },
  {
    name: "时间范围",
    value: "dateRange",
  },
  {
    name: "选择人员",
    value: "list",
  },
  {
    name: "上传附件",
    value: "upload",
  },
  {
    name: "上传图片",
    value: "uploadImg",
  },
];
export const FORM_ITEM_TYPES = generateTypeDic(formItemTypes);

function generateTypeDic(list) {
  let obj = {};
  obj.list = list;
  for (const item of list) {
    obj[item.name] = item.value;
  }
  return obj;
}

export const PARAM_TYPE = {
  VARIABLE: "variable",
  LINK: "link",
  PAGE: "page",
  LOOP: "loop",
  COMPUTED: "computed",
};

export const predefineColors = [
  "#000",
  "#fff",
  "#ff4500",
  "#ff8c00",
  "#ffd700",
  "#90ee90",
  "#00ced1",
  "#1e90ff",
  "#c71585",
  "rgba(255, 69, 0, 0.68)",
  "rgb(255, 120, 0)",
  "hsv(51, 100, 98)",
  "hsva(120, 40, 94, 0.5)",
  "hsl(181, 100%, 37%)",
  "hsla(209, 100%, 56%, 0.73)",
  "#c7158577",
];
export const ACTION_TYPE = {
  PAGE: "page",
  INTERFACE: "interface",
  STATISTIC: "groupCount",
};


// 渲染逻辑用的操作符
export const renderOperators = [
  {
    key: "equal",
    label: "等于(===)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Boolean", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "notEqual",
    label: "不等于(!==)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "greaterThan",
    label: "大于(>)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee"],
  },
  {key: "lessThan", label: "小于(<)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "lessThanInclusive", label: "小于等于(<=)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "greaterThanInclusive", label: "大于等于(>=)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {
    key: "in",
    label: "包含(in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "notIn",
    label: "不包含(not in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: "contains", label: "包含(contains)", fieldShowArr: ["String", "string"]},
  {
    key: "doesNotContain",
    label: "不包含(doesNotContain)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee"],
  },
  // { key: "[a,b]", label: "闭区间([a,b])", fieldShowArr: ["Number", "int", "double", "Date"] },
  // { key: "period", label: "周期(period)", fieldShowArr: ["Date"] },
];
export const operators = [
  {
    key: "=",
    label: "等于(=)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Boolean", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "<>",
    label: "不等于(<>)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: ">", label: "大于(>)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "<", label: "小于(<)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "<=", label: "小于等于(=<)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: ">=", label: "大于等于(>=)", fieldShowArr: ["Number", "int", "double", "Date"]},
  {
    key: "in",
    label: "包含(in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "not in",
    label: "不包含(not in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: "left like", label: "左匹配(left like)", fieldShowArr: ["String", "string"]},
  {key: "like", label: "匹配(Like)", fieldShowArr: ["String", "string"]},
  {
    key: "is null",
    label: "为空(is null)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "is not null",
    label: "不为空(is not null)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: "[a,b]", label: "闭区间([a,b])", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "period", label: "周期(period)", fieldShowArr: ["Date"]},
  {
    key: "max",
    label: "最大值(max)",
    fieldShowArr: ["Date"],
  },
  {
    key: "min",
    label: "最小值(min)",
    fieldShowArr: ["Date"],
  },
];

export const valueTypeOpt = [
  {
    name: "固定值",
    value: "fixedValue",
  },
  {
    name: "页面输入",
    value: "pageEntry",
  },
  {
    name: "固定日期标识",
    value: "fixedDate",
  },
];
export const dateTimeTypeArr = [
  {label: "近3年", value: "n3year"},
  {label: "近2年", value: "n2year"},
  {label: "近1年", value: "n1year"},
  {label: "近6月", value: "n6month"},
  {label: "近6月（含当月）", value: "n6month(in)"},
  {label: "近3月", value: "n3month"},
  {label: "近3月（含当月）", value: "n3month(in)"},
  {label: "近1月", value: "n1month"},
  {label: "近1月（含当月）", value: "n1month(in)"},
  {label: "上周", value: "lastWeek"},
  {label: "近7天", value: "n7days"},
  {label: "近14天", value: "n14days"},
  {label: "昨日", value: "YESTERDAY"},
  {label: "本日", value: "TODAY"},
  {label: "本周至今", value: "WeekToday"},
  {label: "本月至今", value: "MonthToday"},
  {label: "近90天", value: "n90days"},
  {label: "本月", value: "CURRENT_MONTH"},
  {label: "本年", value: "CURRENT_YEAR"},
  {label: "上月", value: "LAST_MONTH"},
  {label: "去年", value: "LAST_YEAR"},
  {label: "近30天", value: "LAST_30_DAYS"},
  {label: "近30天（包含当月）", value: "LAST_30_CUR_DAYS"},
  {label: "近12月", value: "LAST_12_MONTHS"},
  {label: "近12月（包含当月）", value: "LAST_12_CUR_MONTHS"},
  {label: "本年（截止上月底）", value: "CURRENT_YEAR_LAST_MONTH"},
  {label: "本月截止到当天", value: "CURRENT_MONTH_TODAY"},
  {label: "本月截止到昨天", value: "CURRENT_MONTH_YESTERDAY"},
  {label: "本年截至到昨日", value: "CURRENT_YEAR_YESTERDAY"},
];
export const dateAccuracyType = [
  {label: "年", value: "year"},
  {label: "月", value: "month"},
  {label: "日", value: "day", fieldHideArr: ["max", "min"]},
  {label: "时", value: "hour", fieldHideArr: ["max", "min"]},
  {label: "分", value: "minute", fieldHideArr: ["max", "min"]},
  {label: "秒", value: "second", fieldHideArr: ["max", "min"]},
];

export const dateFormatMap = {
  year: {format: "YYYY", type: "year"},
  month: {format: "YYYY-MM", type: "month"},
  day: {format: "YYYY-MM-DD", type: "date"},
  hour: {format: "YYYY-MM-DD HH", type: "datetime"},
  minute: {format: "YYYY-MM-DD HH:mm", type: "datetime"},
  second: {format: "YYYY-MM-DD HH:mm:ss", type: "datetime"},
};
export const DRILL_TYPE = {
  IN: "in",
  OUT: "out",
  DYNAMIC: "dynamic",
};

export function changeToComponentData(fp, keyCode) {
  console.log(fp, 'changeToComponentData')
  let newFp = {
    id: fp.id,
    operationSymbol: fp.operationSymbol,
    rows: [],
  };
  fp[keyCode].forEach((gf) => {
    let nb = JSON.parse(JSON.stringify(gf));
    nb.ruletype = "d";
    newFp.rows.push(nb);
  });
  fp.children.forEach((child) => {
    let nb = JSON.parse(JSON.stringify(child));
    nb.ruletype = "c";
    newFp.rows.push(changeToComponentData(nb, keyCode));
  });
  return newFp;
}

export const LINK_TYPE = {
  STATIC: "static",
  DYNAMIC: "dynamic",
};

export const ABS_SYMBOL = {
  ABS_LEFT: 'abs(',
  ABS_RIGHT: ')'
}
export const INDEX_TYPE = {
  DIMENSION: 'dim',
  METRIC: 'metrics',
  FILTER: 'filter'
}
// 拖拽的指标类型
export const INDEX_DROP_TYPE = {
  DIMENSION: 'dim',
  METRICS: 'metrics',
  FILTER: 'filter',
  GROUP: 'GROUP',
  LINK: 'LINK',
  ASSIST: 'ASSIST',
  TOTAL: 'TOTAL',
  COLUMNS: 'COLUMNS',
  ROW: 'ROW',
  REFERENCE: 'REFERENCE',
  LONGITUDE: 'LONGITUDE',
  LATITUDE: 'LATITUDE',
  METRIC_L: 'METRIC_L',
  METRIC_R: 'METRIC_R',
  LABEL_IDENT: 'labelIdent'
}
// 自定义指标类型 是指标自定义 还是总值自定义
export const CUS_METRIC_MAP = {
  METRIC: "metric",
  ASSIST: "assist",
  TOTAL: "total",
  REFERENCE: "reference",
  LINEMETRIC: 'linemetric',
  BARMETRIC: 'barmetric',
  COLUMNS: 'columns',
  METRIC_L: 'METRIC_L',
  METRIC_R: 'METRIC_R'
};

export const INNER_CONFIG = {
  FIELD: 'field',
  BASIC_CONFIG: 'basicConfig',
  FORMAT: 'format',
  TIME_SHIFT: 'timeShift',
  ADVANCED_CALC: 'advancedCalc',
  INDEX_CONFIG: 'indexConfig',
  DRILLING: 'drilling',
  COLUMN: 'column',
  ADD_CONDITION: 'addCondition'
};

export const LOOP_KEY_MAP = {
  [INDEX_DROP_TYPE.ROW]: 'rows',
  [INDEX_DROP_TYPE.COLUMNS]: 'columns',
  [INDEX_DROP_TYPE.DIMENSION]: 'dimensions',
  [INDEX_DROP_TYPE.GROUP]: 'groups',
  [INDEX_DROP_TYPE.METRICS]: 'metrics',
  [INDEX_DROP_TYPE.REFERENCE]: 'reference',
  [INDEX_DROP_TYPE.ASSIST]: 'assistMetrics',
  [INDEX_DROP_TYPE.TOTAL]: 'totalMetrics',
  [INDEX_DROP_TYPE.LABEL_IDENT]: 'conditions',
  [INDEX_DROP_TYPE.METRIC_R]: 'metricsR',
  [INDEX_DROP_TYPE.METRIC_L]: 'metricsL',
  [INDEX_DROP_TYPE.FILTER]: 'conditions',
}

export const NO_LOADING_COMPONENT = ['indexCard', 'yearMonthTab', 'allAreaSelect', 'textAreaModel', 'time', 'data', 'text', 'datetime', 'img', 'imgborder', 'swiper', 'iframe', 'video', 'clapper', 'flop', 'tabs', 'borderBox', 'decoration', 'test', 'imgTabs', 'headSelect', 'weather']
let barStyle = {
  "option": {
    "xAxisColor": "#86909c",
    "barWidth": 15,
    "xAxisShow": true,
    "xAxisLineWidth": 1,
    "gridY2": 25,
    "legend": true,
    "xAxisTickHide": false,
    "yAxisNameFontSize": 12,
    "barColor": [
      {
        "color1": "#FF7C7C",
        "color2": "#FA5A5A",
        "postion": 100
      },
      {
        "color1": "#F8D25E",
        "color2": "#F7C93F",
        "postion": 100
      }
    ],
    "yAxisShow": true,
    "legendH": 10,
    "yAxisSplitLineShowDotted": true,
    "gridX2": 43,
    "legendOrient": "horizontal",
    "barMinHeight": 2,
    "yAxisSplitLineColor": "#E6E7ED",
    "xAxisLineShow": true,
    "labelShowFontSize": 12,
    "yAxisNameColor": "#86909C",
    "yAxisLineShow": false,
    "column": [],
    "yAxisSplitLineShow": true,
    "tipShow": true,
    "gridX": 90,
    "gridY": 47,
    "yAxisName": "单位：%",
    "yAxisLineColor": "#6e7079",
    "xAxisLineColor": "#E6E6E6",
    "xAxisFontSize": 12,
    "yAxisFontSize": 12,
    "showYAxisName": true,
    "legendFontColor": "#1d2129",
    "legendFontSize": 12,
    "yAxisColor": "#4e596999",
    "subYAxis": {
      "xAxisLineShow": true,
      "xAxisColor": "#6e7079",
      "barWidth": 30,
      "xAxisShow": true,
      "labelShowFontSize": 12,
      "gridY2": 25,
      "legend": true,
      "yAxisLineShow": true,
      "tipShow": true,
      "barColor": [
        {
          "color1": "#83bff6",
          "color2": "#188df0",
          "postion": 90
        },
        {
          "color1": "#23B7E5",
          "color2": "#564AA3",
          "postion": 50
        }
      ],
      "yAxisShow": true,
      "gridX": 90,
      "gridY": 47,
      "yAxisLineColor": "#6e7079",
      "xAxisLineColor": "#6e7079",
      "xAxisFontSize": 12,
      "yAxisFontSize": 12,
      "legendFontSize": 12,
      "gridX2": 43,
      "yAxisColor": "#6e7079",
      "barRadius": 0,
      "tipFontSize": 12,
      "barMinHeight": 2
    },
    "barRadius": 0,
    "legendPosition": "tr",
    "tipFontSize": 12,
    "legendW": 14
  }
}
export const STYLR_TEMPLATE = {
  ZHI_NAO: {
    templateName: '中材红',
    progress: {
      option: {
        "strokeWidth": 7,
        "color": "#484A4D",
        "type": "line",
        "FontWeight": "normal",
        "suffixPosition": true,
        "fontWeight": "normal",
        "striped": false,
        "suffixFontSize": 0,
        "labelShowFontSize": 12,
        "suffixFontWeight": "normal",
        "showPercentage": true,
        "unachievedColor": "#E6E6E6",
        "suffixColor": "#60d3da",
        "achievedColor": "#FC7777",
        "fontSize": 14,
        "tipFontSize": 12
      }
    },
    line: {
      "option": {
        "xAxisColor": "rgba(78, 89, 105, 0.6)",
        "xAxisShow": true,
        "gridY2": 31,
        "legend": true,
        "xAxisTickHide": true,
        "yAxisNameFontSize": 12,
        "barColor": [
          {
            "color1": "rgba(250, 90, 90, 1)",
            "color2": "rgba(255, 124, 124, 1)",
            "postion": 90
          },
          {
            "color1": "rgba(248, 210, 94, 1)",
            "color2": "#F7C93F",
            "postion": 90
          },
          {
            "color1": "#81A6FF",
            "color2": "#81A6FF",
            "postion": 90
          }
        ],
        "yAxisShow": true,
        "legendH": 9,
        "lineWidth": 2,
        "yAxisSplitLineShowDotted": true,
        "symbolKind": "emptyCircle",
        "yAxisNameFontFamily": "Microsoft YaHei",
        "gridX2": 26,
        "smooth": true,
        "yAxisSplitLineColor": "#E5E6EB",
        "labelShowFontSize": 12,
        "xAxisNameColor": "",
        "yAxisNameColor": "rgba(78, 89, 105, 0.6)",
        "symbolSize": 6,
        "yAxisLineShow": false,
        "column": [],
        "yAxisSplitLineShow": true,
        "xAxisSplitLineColor": "rgba(78, 89, 105, 0.6)",
        "tipShow": true,
        "symbolShow": true,
        "gridX": 65,
        "gridY": 50,
        "areaStyle": false,
        "yAxisLineColor": "#6e7079",
        "xAxisLineColor": "#E6E6E6",
        "xAxisFontSize": 12,
        "yAxisFontSize": 12,
        "showYAxisName": true,
        "xAxisName": "",
        "legendFontColor": "#000000",
        "legendFontSize": 11,
        "yAxisColor": "rgba(78, 89, 105, 0.6)",
        "legendPosition": "tr",
        "tipFontSize": 12,
        "showXAxisName": false
      }
    },
    mixBarNew: {
      "option": {
        "barWidth": 30,
        "rightAxisNameColor": "rgba(78, 89, 105, 0.6)",
        "xAxisShow": true,
        "gridY2": 25,
        "legend": true,
        "yAxisSplitLineShowDotted": true,
        "xAxisSplitLineShow": false,
        "rightAxisLineShow": false,
        "yAxisLabelShow": true,
        "gridX2": 80,
        "barMinHeight": 2,
        "yAxisSplitLineColor": "#E5E6EB",
        "rightAxisColor": "rgba(78, 89, 105, 0.6)",
        "labelShowFontSize": 12,
        "yAxisLineShow": false,
        "rightAxisShow": true,
        "yAxisSplitLineShow": true,
        "rightAxisNameFontSize": 12,
        "rightAxisSplitLineShowDotted": false,
        "sameyAxis": false,
        "rightAxisSplitLineShow": false,
        "yAxisFontFamily": "Microsoft YaHei",
        "gridX": 40,
        "rightAxisFontFamily": "Microsoft YaHei",
        "gridY": 35,
        "yAxisLineColor": "#6e7079",
        "xAxisLineColor": "#E6E6E6",
        "showYAxisName": true,
        "showRightAxisName": true,
        "rightAxisLabelShow": true,
        "legendFontColor": "#1D2129",
        "legendW": 9,
        "xAxisColor": "rgba(78, 89, 105, 0.6)",
        "yAxisNameFontSize": 12,
        "barColor": [
          {
            "color1": "#FF7C7C",
            "color2": "#FA5A5A",
            "postion": 100
          },
          {
            "color1": "#FFAF58"
          }
        ],
        "yAxisShow": true,
        "rightAxisLineColor": "rgba(134, 144, 156, 1)",
        "yAxisSplitLineWidth": 1,
        "yAxisNameFontFamily": "Microsoft YaHei",
        "rightAxisNameFontFamily": "Microsoft YaHei",
        "smooth": true,
        "yAxisNameColor": "rgba(78, 89, 105, 0.6)",
        "legendIcon": "circle",
        "legendTop": "1",
        "rightAxisFontSize": 12,
        "column": [],
        "tipShow": true,
        "rightAxisLineWidth": 1,
        "xAxisFontSize": 12,
        "yAxisFontSize": 12,
        "legendFontSize": 12,
        "yAxisColor": "rgba(78, 89, 105, 0.6)",
        "subYAxis": {
          "xAxisColor": "#6e7079",
          "barWidth": 30,
          "xAxisShow": true,
          "labelShowFontSize": 12,
          "gridY2": 25,
          "legend": true,
          "tipShow": true,
          "barColor": [
            {
              "color1": "#83bff6",
              "color2": "#188df0",
              "postion": 90
            },
            {
              "color1": "#23B7E5",
              "color2": "#564AA3",
              "postion": 50
            }
          ],
          "yAxisShow": true,
          "gridX": 90,
          "gridY": 47,
          "yAxisLineColor": "#6e7079",
          "xAxisLineColor": "#E6E6E6",
          "xAxisFontSize": 12,
          "yAxisFontSize": 14,
          "legendFontSize": 12,
          "yAxisColor": "#6e7079",
          "gridX2": 80,
          "barRadius": 0,
          "tipFontSize": 12,
          "barMinHeight": 2
        },
        "barRadius": 0,
        "tipFontSize": 12
      }
    },
    horizontalBar: barStyle,
    bar: barStyle,
    pieCircleIndex: {
      "option": {
        "legend": true,
        "labelShow": true,
        "legendType": "legend",
        "layoutType": "row",
        "legendIcon": "rect",
        "xAxisColor": "#6e7079",
        "xAxisLineColor": "#E6E6E6",
        "yAxisColor": "#6e7079",
        "yAxisLineColor": "#6e7079",
        "yAxisNameColor": "#6e7079",
        "tipFontSize": 12,
        "xAxisFontSize": 12,
        "yAxisFontSize": 12,
        "labelShowFontSize": 12,
        "legendFontSize": 12,
        "legendPosition": "rc",
        "barColor": [
          {
            "color1": "rgba(250, 90, 90, 1)"
          },
          {
            "color1": "rgba(253, 161, 81, 1)"
          },
          {
            "color1": "rgba(249, 210, 92, 1)"
          },
          {
            "color1": "rgba(251, 167, 175, 1)"
          },
          {
            "color1": "rgba(129, 166, 255, 1)"
          },
          {
            "color1": "rgba(193, 150, 223, 1)"
          },
          {
            "color1": "rgba(52, 209, 205, 1)"
          }
        ],
        "cardType": "line",
        "dataSourceType": "bizCount",
        "selectedColorIndex": 0,
        "size": "large",
        "colorType": "single",
        "valueSize": "mini",
        "titleFontSize": 14,
        "valueFontSize": 20,
        "titleColor": "#6e7079",
        "valueColor": "rgb(72, 74, 77)",
        "assistColor": "#6e7079",
        "assistFontSize": 12,
        "assistDesColor": "#6e7079",
        "assistDesFontSize": 12,
        "mainAssistType": "row",
        "layoutNumber": 70,
        "xCenter": 32,
        "yCenter": 50,
        "xRadius": 60,
        "yRadius": 80,
        "legendW": 10,
        "legendH": 10,
        "legendFontColor": "rgb(72, 74, 77)",
        "mainGap": 14,
        "showCenterLabel": false,
        "tipConfine": true,
        "ref": "ref_1742282805629018",
        "styleTemplate": "ZHI_NAO",
        "totalValueColor": "rgb(72, 74, 77)",
        "totalLabelColor": "rgb(120, 122, 128)",
        "blankInterval": 8
      },
    }
  }
}

export const ServiceTypeList = {
  market: DATA_SOURCE_TYPE.DATA_CENTER,
  biz_unit_app: DATA_SOURCE_TYPE.REPORT,
  biz_unit: 'biz_data_model',
  folder: 'dataset'
}

export const DEFAULT_VALUE_TYPR = {
  CLEAR: "_clearValue_",
};